import { apiPost, apiGet, apiDelete, API_ENDPOINTS } from "../utils/apiUtils";

/**
 * Dashboard Service
 * Handles dashboard data fetching
 */
const DashboardService = {
  /**
   * Get dashboard counts
   * @param {Object} dateRange - Date range filters
   * @param {string} dateRange.startDate - Start date in ISO format
   * @param {string} dateRange.endDate - End date in ISO format
   * @returns {Promise} API response with dashboard counts
   */
  async getDashboardCounts(dateRange) {
    return apiPost(API_ENDPOINTS.DASHBOARD.GET_COUNTS, dateRange);
  },

  /**
   * Get dashboard commission
   * @param {Object} dateRange - Date range filters 
   * @returns {Promise} API response with commission data
   */
  async getCommission(dateRange) {
    return apiGet(API_ENDPOINTS.DASHBOARD.GET_COMMISSION, dateRange);
  },
};

export default DashboardService;

